export const VIDEO_WIDTH = 1280;
export const VIDEO_HEIGHT = 960;
export const VIDEO_FPS = 30;
